import closeIcon from "../../assets/imgs/close-modal-icon.svg";
import errorIcon from "../../assets/imgs/modal-error.png";
import { t } from "../../services/formatters";
import { Button } from "../Button";
import { useSession } from "../../hooks/useSession";
import { useEditAppointment } from "../../hooks/useEditAppointment";
import "./style.css";
import { TextInput } from "../TextInput";
import { isCf } from "../../services/validators";
import { useGeo } from "../../hooks/useGeo";

export const EditAppointmentModal = ({ open = false, onCloseModal = () => {}, title = "", text = "" }) => {
    const { read, update } = useSession();

    const { showModal, setShowModal, closeModal, setCodiceFiscale, codiceFiscale, codiceFiscaleError, askForEditAppointment, prepareDataForEditAppointment, busy, setCodiceFiscaleError } =
        useEditAppointment();

    const getCfInputStatus = () => {
        return codiceFiscale.length == 16 && isCf(codiceFiscale) ? 3 : codiceFiscale.length == 16 && !isCf(codiceFiscale) ? 4 : 1;
    };
    const isButtonDisabled = () => {
        return getCfInputStatus() != 3 && !read("codiceFiscale");
    };
    const isButtonBusy = () => {
        return busy;
    };
    const _onCloseModal = () => {
        setCodiceFiscaleError("");
        onCloseModal();
    };

    return (
        <div className={`modal-component modal-container ${open ? "open" : ""}`}>
            {/* <div onClick={_onCloseModal} className="modal-backdrop"></div> */}
            <div className="modal-backdrop"></div>

            <div className="modal-content">
                <div onClick={_onCloseModal} className="close-modal-icon modal-element text-right">
                    <img className="clickable" src={closeIcon} />
                </div>

                <div className={`section white-box input-box-component`}>
                    <h2 className="text-center">{title}</h2>
                    <br />
                    <div className="text-center">
                        <p dangerouslySetInnerHTML={{ __html: text }}></p>
                        <br />

                        {!read("codiceFiscale") && (
                            <>
                                <TextInput
                                    state={getCfInputStatus()}
                                    name="codiceFiscaleEdit"
                                    maxLength={16}
                                    value={codiceFiscale}
                                    onChange={(value) => {
                                        setCodiceFiscaleError(false);
                                        setCodiceFiscale(value);
                                    }}
                                    placeholder={t("inserisci_cf")}
                                />
                                <br />
                            </>
                        )}

                        <Button disabled={isButtonDisabled()} loading={isButtonBusy()} text={t("avanti")} classList="btn-responsive always-style" onClick={prepareDataForEditAppointment} />
                    </div>
                    <br />

                    {codiceFiscaleError && <p className="error text-center">{t("cf_inesistente")}</p>}
                </div>
            </div>
        </div>
    );
};
